<template>
  <div>
    <van-popup
      v-model="show"
      class="full-height full-width verificate linear-main3"
      :get-container="element || ''"
      :close-on-popstate="true"
      position="right"
    >
      <ld-header
        @click-left="show = false"
        class="font-lg white"
        transparent
        white
      >
        联系方式核验
      </ld-header>

      <div class="white pad8">
        <van-row class="font-lg font20 mt5 padLR8">
          请完成联系方式核验
        </van-row>
        <van-row class="font12 mt5 padLR8">
          乘客更新成功，请完成手机号核验
        </van-row>
      </div>

      <div class="pad8 bg-white round-lg">
        <van-row class="font-lg font20 mt5 padLR8">
          请按照下方步骤完成核验
        </van-row>
        <van-row class="font12 mt5 gray padLR8">
          请您通知{{ psgInfo | getName }}，使用
          <span class="main-color">{{ psgInfo.phoneNumber }}</span>
          在60分钟内向
          <span class="main-color">12306</span>
          发送下方短信验证码完成核验
        </van-row>

        <van-row class="verificate-box mt5 round-md">
          <van-row class="font-lg font16 mt5">
            1. 获取验证码
          </van-row>
          <van-row
            type="flex"
            class="mt5 main-color"
            align="center"
          >
            <van-col span="5">
              {{ psgInfo.yzm }}
            </van-col>
            <van-col span="5">
              <ld-button
                defaults
                size="sm"
                @click="refresh12306Passed"
              >
                刷新
              </ld-button>
            </van-col>
          </van-row>
          <van-row class="font-lg font16 mt5">
            2. 发送短信
          </van-row>
          <van-row
            class="mt5"
            ref="SendContent"
          >
            请使用手机号码
            <span class="main-color">{{ psgInfo.phoneNumber }}</span>
            在30分钟内发送短信
            <span class="main-color">{{ psgInfo.yzm }}</span>
            至号码
            <span class="main-color">12306</span> 进行核验。<br>
            请您尽快完成，以免影响继续购票。
          </van-row>
          <van-row
            class="verificate-box__buttons"
            gutter="10"
          >
            <van-col span="12">
              <ld-button
                defaults
                size="lg"
                @click="openMsm"
              >
                本人手机验证
              </ld-button>
            </van-col>
            <van-col span="12">
              <ld-button
                main2
                size="lg"
                @click="sendMsm"
              >
                告知好友验证
              </ld-button>
            </van-col>
          </van-row>
        </van-row>
      </div>

      <van-row class="verificate-status bg-white round-lg font18">
        <template v-if="type == TravelVerificateType[12306]">
          <van-col span="19">
            手机核验状态: 
            <span
              v-if="psgInfo.passed"
              class="green"
            >已通过</span>
            <span
              v-else
              class="red"
            >待核验</span>
          </van-col>
          <van-col span="5">
            <ld-button
              main2
              size="sm"
              @click="refresh12306Passed"
            >
              刷新
            </ld-button>
          </van-col>
        </template>
        <template v-else>
          <van-col span="19">
            当前核验状态: 
            <span v-html="CheckCodeDesc[psgInfo.checkCode]" />
          </van-col>
          <van-col span="5">
            <ld-button
              main2
              size="sm"
              @click="refreshCheckCode"
            >
              刷新
            </ld-button>
          </van-col>
        </template>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup } from 'vant'
import ldButton from 'Common/ldButton'

import TrainBookInteractor, { TravelVerificateType } from 'Domain/use-cases/train-book-interactor'

const CheckCodeDesc = {
  '-1' : '<span class="red">未通过</span>',
  '0': '<span class="red">待核验</span>',
  '2': '<span class="red">待核验</span>',
  '1': '<span class="green">已通过</span>',
  '3': '<span class="red">未通过</span>',
  'loading': '核验中'
}

export default {
  name: 'Verificate',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    ldButton
  },
  props: {
    element:{
      type: String,
      default: ''
    },
    psgInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      show: false,
      CheckCodeDesc,
      TravelVerificateType,
      verificateCode: '',
    }
  },
  created() {
    // console.log(this.psgInfo)
  },
  methods: {
    openMsm () {
      let msg = plus.messaging.createMessage(plus.messaging.TYPE_SMS)
      msg.to = ['12306']
      msg.body = this.psgInfo.yzm
      plus.messaging.sendMessage( msg )
    },
    async sendMsm () {
      try {
        const param = {
          phoneNumber: this.psgInfo.phoneNumber,
          sendContent: this.$refs['SendContent'].$el.innerText.replace(/\ +/g,'')
        }
        await this.$api['common/smsSend'](param)
        this.$toast.success('短信发送成功')
      } catch (error) {
        throw error
      }
    },
    async refreshCheckCode() {
      const travelerList = [this.psgInfo]
      const { checkCodes } = await TrainBookInteractor.verificate(travelerList, false)
      this.$set(this.psgInfo, 'checkCode', checkCodes[0])
    },
    async refreshVerificateCode () {
      const verificateCode = await TrainBookInteractor.getVerificateCode(this.psgInfo)
      this.$set(this.psgInfo, 'yzm', verificateCode)
    },
    refresh12306Passed() {
      this.$emit('refresh')
    },
    toggle(show) {
      this.show = show === undefined ? !this.show : show
    }
  }
}
</script>

<style lang="less">
.verificate {
  padding: 0 8px 0;

  .verificate-box {
    padding: 14px;
    background-color: @color-background-gray;

    .verificate-box__buttons {
      margin-top: 14px;
    }
  }

  .verificate-status {
    margin-top: 10px;
    padding: 16px;
  }

  .padLR8 {
    padding: 0 8px;
  }
}
</style>
